export default __webpack_public_path__ + "static/media/myLocation.5f2843c0.svg";